export function mapViewInfo(mapPosition) {
  var _mapPosition$camera$p, _mapPosition$camera$b, _mapPosition$camera$a;

  // Switch to 3D mode at high zoom levels or with a rotated map
  var pitch = (_mapPosition$camera$p = mapPosition.camera.pitch) !== null && _mapPosition$camera$p !== void 0 ? _mapPosition$camera$p : 0;
  var bearing = (_mapPosition$camera$b = mapPosition.camera.bearing) !== null && _mapPosition$camera$b !== void 0 ? _mapPosition$camera$b : 0;
  var alt = (_mapPosition$camera$a = mapPosition.camera.altitude) !== null && _mapPosition$camera$a !== void 0 ? _mapPosition$camera$a : 10000000;
  var mapIsRotated = pitch != 0 || bearing != 0;
  var mapIsGlobal = alt > 1600000;
  var mapUse3D = false;

  if (alt != null) {
    mapUse3D = pitch > 0 && alt < 200000 || alt < 80000;
  }

  return {
    mapIsRotated: mapIsRotated,
    mapUse3D: mapUse3D,
    mapIsGlobal: mapIsGlobal
  };
}